export const routes = {
  // open
  LOGIN: "/login",
  REGISTER: "/register",

  // secured
  HOME: "/",
  PROFILE_PAGE: "/profile",
  PROJECT_LIST_PAGE: "/projects",
  VARIATION_LIST_PAGE: "/variations",
  VARIATION_DETAILS_PAGE: "/variations/details",

  // admin
  USER_LIST_PAGE: "/users",
};
